export const salesData = [
    { name: "Jan", sales: 4000, category: "Electronics" },
    { name: "Feb", sales: 3000, category: "Clothing" },
    { name: "Mar", sales: 5000, category: "Electronics" },
    { name: "Apr", sales: 4000, category: "Furniture" },
    { name: "May", sales: 6000, category: "Clothing" },
  ];